<template>
  <div class="wrapper-content w-100">
    <h1>Form</h1>
    <LmForm ref="lmFormRef">
      <LmEmailInput
        v-model="form.email"
        :v="$v.form.email"
        label="Email"
        placeholder="Email"
        />
      <LmColorPicker label="color" value="#ff0000" />
      <LmTextInput
        v-model="form.text"
        label="input list"
        placeholder="Text"
        @search="simuleRequest"
        :isProcessingInputList="isProcessingInputList"
        :modeItemsInputList="true"
        :itemsInputList="itemsInputList"
        />
      <LmNumberInput
        v-model="form.number"
        :v="$v.form.number"
        label="Number"
        placeholder="Number"
        />
      <LmTextArea
        v-model="form.textArea"
        :v="$v.form.textArea"
        label="Text Area"
        placeholder="Text Area"
        :max-length=10
        />
      <LmSelect
        v-model="form.select"
        :v="$v.form.select"
        :options="options"
        label="Select"
        />
      <LmSuperPowerSelectV2
        multiple
        :options="lmSuperPowerSelectV2Options"
        v-model="lmSuperPowerSelectV2OptionsSelected"
        urlPathFromGetOptions="oficinas/secretarias/"
        label="Label spsv2"
      />
      <LmDateTime
        v-model="form.dateTime"
        :v="$v.form.dateTime"
        placeholder="Select Date"
        label="Select Date Time"
        />
      <LmDate
        v-model="form.date"
        :v="$v.form.date"
        placeholder="Select Date"
        label="Select Date"
        id="selectDate"
        :layout="['form-group']"
        />
      <LmUploadFiles
        label="File"
        ref="lmUploadFiles"
        class="mb-3"
        :dropzoneOptions="dropzoneOptions"
        @vdropzone-removed-file="fileRemoved"
        @vdropzone-success="fileUploaded"
        :v="$v.form.file"
      />
      <Lmcomment comment="Este es mi comentario" commentPrefix="NOTA INTERNA -" />
      <b-form-input
        class="mb-3"
        list="my-list-id"
        @input="inputDataList"
        :value="sizes[0].name"/>
      <b-datalist id="my-list-id">
        <option>Manual Option</option>
        <option v-for="(size, index) in sizes" :key="index">
          {{ size.name }}
        </option>
      </b-datalist>
      <LmButton
        type="button"
        buttonClass="btn-secondary"
        :value="$t('Cancel')"
        @click.native="cancelBtn"
        />
        <LmButton type="button" value="Submit" @click.native="submit()"/>
    </LmForm>
  </div>
</template>

<script>
import store from '@/store'
import formValidation from '@/components/form/LmFormValidation'

import LmForm from '@/components/form/LmForm.vue'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmSelect from '@/components/form/elements/LmSelect'
import LmDateTime from '@/components/form/elements/LmDateTime'
import LmDate from '@/components/form/elements/LmDate'
import LmButton from '@/components/form/elements/LmButton'
import LmUploadFiles from '@/components/LmUploadFiles'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2'
import LmColorPicker from '@/components/form/elements/LmColorPicker'
import Lmcomment from '@/components/LmComment'
export default {
  components: {
    LmForm,
    LmTextInput,
    LmNumberInput,
    LmEmailInput,
    LmButton,
    LmTextArea,
    LmSelect,
    LmDateTime,
    LmDate,
    LmUploadFiles,
    LmSuperPowerSelectV2,
    LmColorPicker,
    Lmcomment
  },
  data () {
    return {
      isProcessingInputList: false,
      itemsInputList: [],
      lmSuperPowerSelectV2OptionsSelected: [
        { id: 4, name: '4 SECRETARIA DE FISCALIZACION Y CONTROL' },
        { id: 111, name: '111 SECRETARIA DE SALUD Y DESARROLLO HUMANO' }
      ],
      sizes: [{ name: 'Small', id: 0 }, { name: 'Medium', id: 1 }, { name: 'Large', id: 2 }, { name: 'Extra Large', id: 3 }],
      form: {
        email: '',
        text: '',
        number: null,
        textArea: '',
        select: '',
        dateTime: null,
        date: null,
        file: null,
        dataList: ''
      },
      options: {
        disabledOption: 'Please select an option',
        content: ['A', 'B', 'C', 'D']
      },
      lmSuperPowerSelectV2Options: [
        { id: 1, name: '1 SECRETARIA DE RECURSOS HUMANOS' },
        { id: 4, name: '4 SECRETARIA DE FISCALIZACION Y CONTROL' },
        { id: 10, name: '10 SECRETARIA DE INGRESOS PUBLICOS' },
        { id: 14, name: '14 SECRETARIA DE HACIENDA Y FINANZAS' },
        { id: 102, name: '102 SECRETARIA DE GOBIERNO Y LEGAL Y TECNICA' },
        { id: 111, name: '111 SECRETARIA DE SALUD Y DESARROLLO HUMANO' },
        { id: 130, name: '130 SECRETARIA GENERAL' }
      ],
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}documentos/nuevo/?id=2`,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null,
          Authorization: `Bearer ${store.state.session.accessToken}`
        },
        withCredentials: true,
        thumbnailWidth: 150,
        maxFiles: 1,
        addRemoveLinks: true,
        acceptedFiles: 'image/*'
      }
    }
  },
  validations: {
    form: formValidation
  },
  methods: {
    simuleRequest () {
      this.isProcessingInputList = true
      if (Math.random() > 0.5) {
        setTimeout(() => {
          this.itemsInputList = [
            { id: 1, text: 'item 1', value: 'itemValue1' },
            { id: 2, text: 'item 2', value: 'itemValue2' }
          ]
          this.isProcessingInputList = false
        }, 1000)
      } else {
        this.itemsInputList = []
        this.isProcessingInputList = false
      }
    },
    inputDataList (event) {
      const selectedValue = this.sizes.find(el => el.name === event)
      this.form.dataList = selectedValue
    },
    fileUploaded (file, response) {
      console.log('file', file)
      console.log('response', response)
      this.form.file = response.path
    },
    fileRemoved () {
      console.log('fileremove')
      this.form.file = ''
    },
    async submit () {
      await this.$refs.lmFormRef.validationForm(this.$v)
    }
  },
  mounted () {
    if (this.$route.query.mode === 'edit') {
      this.$refs.lmFormRef.activeEditMode({
        path: 'expedientes/activos/edit/',
        id: '821268'
      })
    }
  }
}
</script>
